import React, { Fragment, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Container, Box, IconButton, Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { Formik } from "formik"
import * as Yup from "yup"
// import Loading from "components/Loading"
import { openSnackBar } from "actions/snack-bar"
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos"
import InfoIcon from "@material-ui/icons/Info"
import { addOrg } from "actions/user"
import { getUser } from "actions/user"
import { loginSuccess } from "actions/authentication"
import { isPWA } from "utils/isPWA"
import { getCurrentOrg } from "actions/organization"
import { useHistory } from "react-router-dom"
import LoaderButton from "components/LoaderButton"
import MaskedOrganizationCode from "components/MaskedOrganizationCode"
import ReusableFormControl from "components/ReusableFormControl"
const codeSchema = Yup.object().shape({
  code: Yup.string().required("Required")
})

const AddOrg = ({ classes }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { token, user, isLoading } = useSelector(state => ({
    token: state.authentication.token,
    user: state.authentication.authenticatedUser,
    isLoading: state.isLoading.loading
  }))
  const [anchorEl, setAnchorEl] = useState(null)

  const toggleHelp = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? "transitions-popper" : undefined

  return (
    <Fragment>
      <Container>
        <Box className={classes.topBar}>
          <IconButton style={{ zIndex: 1 }} className={classes.iconButton}>
            <ArrowBackIosIcon
              onClick={() => {
                history.goBack()
              }}
              className={classes.backIcon}
            />
          </IconButton>
          <Typography className={classes.title} variant="h6">
            Add Organization
          </Typography>
        </Box>
        <Formik
          initialValues={{ code: "" }}
          validationSchema={codeSchema}
          onSubmit={(values, { setSubmitting }) => {
            // Add user to org
            let orgId = 0
            dispatch(addOrg(values.code))
              .then(res => {
                const subdomain = res.subdomain
                dispatch(openSnackBar({ message: res.message }))
                if (res.org_id) {
                  orgId = res.org_id
                  // Get updated user data
                  dispatch(getUser(user.id, token))
                    .then(res => {
                      // Update user data in redux
                      dispatch(loginSuccess(res, token))
                      const host = window.location.host.split(".")
                      if (isPWA()) {
                        dispatch(getCurrentOrg(orgId)).then(res => {
                          history.push("/app/feed")
                        })
                      } else {
                        window.location = `http://${subdomain}.${host[1]}.${host[2]}/app/feed?token=${token}&user=${user.id}`
                      }
                    })
                    .catch(error => {
                      console.log(error)
                    })
                }
                setSubmitting(false)
              })
              .catch(error => error)
          }}
        >
          {formikProps => {
            const { isSubmitting, handleSubmit } = formikProps
            return (
              <form className={classes.form}>
                <Typography variant="h6" align="center">
                  Enter organization code:
                </Typography>
                <ReusableFormControl
                  label="Enter Code"
                  name="code"
                  formikProps={formikProps}
                  InputProps={{
                    inputComponent: MaskedOrganizationCode
                  }}
                />
                <button
                  aria-describedby={id}
                  className={classes.helpToggle}
                  type="button"
                  onClick={toggleHelp}
                >
                  <InfoIcon color="primary" />
                  <Typography style={{ marginLeft: "8px" }}>
                    Need help?
                  </Typography>
                </button>
                {open && (
                  <Box className={classes.helpInfo}>
                    The organization code is a unique 6-digit code. Please reach
                    out to your admistrator if you do not know the code.
                  </Box>
                )}
                <Box className={classes.submitContainer}>
                  <LoaderButton
                    working={isLoading}
                    onClick={handleSubmit}
                    classes={{ button: classes.submitButton }}
                    color="primary"
                    disabled={isSubmitting}
                  >
                    Join
                  </LoaderButton>
                </Box>
              </form>
            )
          }}
        </Formik>
        {/* {isLoading && <Loading />} */}
      </Container>
    </Fragment>
  )
}

export default withStyles(styles)(AddOrg)



// WEBPACK FOOTER //
// ./src/pages/App/AddOrg/index.js